import { permitir_consultar_alunos_matriculados_por_escola_turma } from "./permitir-consultar-alunos-matriculados-por-escola-turma/permitir-consultar-alunos-matriculados-por-escola-turma";
import { emitir_relacao_de_alunos_nao_enturmados } from "./emitir-relacao-de-alunos-nao-enturmados/emitir-relacao-de-alunos-nao-enturmados";

import { enturmacao_de_alunos } from "./enturmacao-de-alunos/enturmacao-de-alunos";
const enturmar_alunos = [
  permitir_consultar_alunos_matriculados_por_escola_turma,
  emitir_relacao_de_alunos_nao_enturmados,
  enturmacao_de_alunos,
];

export { enturmar_alunos };
